<template>
  <div>
    <v-card v-if="!isPaysafeSuccess && !isPaysafeError" class="mx-auto pa-6 mt-6" max-width="400">
      <v-card-text class="text-center">
        Nom: {{ entite.nom }}
        <br />        
        Prénom: {{ entite.prenom }}
        <br />
        Montant : {{ entite.montantTotal }} $
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          :disabled="loading" 
          :loading="loading" 
          @click="payNow"
        >
          Payer
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="isPaysafeSuccess"  class="mx-auto pa-6 mt-6" max-width="400">
      <v-card-text class="text-center">
        "Paiement réussi !"
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="closeModal(true)" >
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="isPaysafeError" class="mx-auto pa-6 mt-6" max-width="400">
      <v-card-text class="text-center">
        Une erreur est survenue :
        <br />        
        Erreur {{ error.code }} : {{ error.displayMessage }}
        <br />
        {{ error.detailedMessage }}  
        <br />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="closeModal(true)" >
          Fermer
        </v-btn>
      </v-card-actions>  
    </v-card>
      
  </div>
</template>

<script>
import { eSpecif } from "@/utils/eSpecif"
import SaisirPaiementPaysafeApi from "@/mixins/services/saisirPaiementPaysafeApi"
import PaysafeModale from "@/mixins/paysafeModale"

export default {
  mixins: [SaisirPaiementPaysafeApi,PaysafeModale],
  data() {
    return {
      tab: 0,
      fileId: 0,
      entite: {
        nom: "",
        prenom: "",
        montantTotal: 0
      },
      loading: false,
      isPaysafeSuccess: false,
      isPaysafeError: false,
      error: {
        code: "",
        displayMessage: "",
        detailedMessage: ""
      },
      // On ne préremplie pas d'adresse de facturation dans ce cas précis
      paramsModale: { billingAddress: null }
    }
  },

  mounted() {
    this.loadAndSetup()
  },

  methods: {
    loadAndSetup() {
      this.loading = true
      this.loadFileInfos()
        .then((res) => {
                  this.tab = res.data.tab
                  this.fileId = res.data.fileId
                  this.entite = res.data.entite
                  })
        .then(() => this.loading = false)
    },

    payNow() {
      this.loading = true
      this.showPaysafeModale(this.entite.montantTotal, `${this.entite.prenom} ${this.entite.nom}`)
    },

    onSuccessPaysafe(token) {
      this.sendProcessPayment(this.fileId, this.entite.montantTotal, token)
        .then((res) => {
          const paiementReussi = res.data.paiementReussi
          if (paiementReussi) {
            this.isPaysafeSuccess = true
          }
          else
          {
            this.error.code = res.data.errorCode
            this.error.displayMessage = res.data.errorMessage
            this.isPaysafeError = true
          }
        })
        .catch((err) => {
          this.error.code = err.name
          this.error.displayMessage = err.message
          this.isPaysafeError = true
        })
        .finally(() => {
          this.loading = false
        })
    },

    onFailurePaysafe(errorCode, displayMessage, detailedMessage) {
      this.error.code = errorCode
      this.error.displayMessage = displayMessage
      this.error.detailedMessage = detailedMessage
      this.isPaysafeError = true
      this.loading = false
    },

    closeModal(withRefresh) {
      let spe = new eSpecif(1)
      if (withRefresh === true) {
        spe.LoadFile(this.tab, this.fileId)
      }
      setTimeout(() => {
        spe.CloseModalSpecif()
      }, 500)
    }
  }
}
</script>

<style scoped>
</style>
